import { type ReactNode, createContext, useCallback, useContext } from "react"
import type { TranslationKey } from "../lib/i18n.js"
import { RootStore } from "./RootStore.js"

const StoreContext = createContext<RootStore | null>(null)

const rootStore = new RootStore()

export function StoreProvider({ children }: { children: ReactNode }) {
  return <StoreContext.Provider value={rootStore}>{children}</StoreContext.Provider>
}

export function useStore(): RootStore {
  const store = useContext(StoreContext)
  if (!store) throw new Error("useStore must be used within StoreProvider")
  return store
}

/**
 * Convenience hook that returns the i18n translate function bound to the current locale.
 * Must be used inside an `observer()` component so the component re-renders on locale change.
 */
export function useT(): (key: TranslationKey) => string {
  const { i18nStore } = useStore()
  return useCallback((key: TranslationKey) => i18nStore.t(key), [i18nStore])
}
